import React from 'react';
import ServiceDetail from '@/components/services/ServiceDetail';

export default function GarageDoorRepair() {
  return <ServiceDetail serviceKey="repair" />;
}